// extracted by mini-css-extract-plugin
export default {"avatar":"styles__avatar___pezdB","avatar-size":"styles__avatar-size___T8tee"};